<template>
  <div id="date" class="main-wrapper">
    <Modal
      v-if="components.chooseDate"
      title="开课日期"
      :tapToDismiss="true"
      :showComplete="false"
      v-on:dismiss="components.chooseDate = false"
      v-on:complete="components.chooseDate = false"
    >
      <div class="choose-date">
        <div
          v-for="(item, key) in openingDates"
          :key="key"
          class="radio radio-multiline"
          @click="openingDate = item"
        >
          <div
            :class="{ selected: openingDate.mmdd === item.mmdd }"
            class="radio-item-wrapper"
            @click="sessions = item"
          >
            <div class="radio-item">
              <div class="radio-circle">
                <i class="anyteachicon anyteach-check" />
              </div>
              <span class="radio-text"
                >{{ item.dateText }}{{ item.dayText }} {{ item.time }} - {{ item.timeEnd }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Modal>
    <div class="back-button" @click="$emit('state', -1)">
      <i class="anyteachicon anyteach-caret-square-left" />上一步
    </div>
    <div class="section-header">选择开课日期和上课地点</div>
    <div id="select-dates-wrapper" class="select-wrapper">
      <h2 class="title">
        开课日期
        <span
          v-if="datesOfClasses[0]"
          class="show-dates animated fadeInRight"
          @click="isShowCalendar = true"
          >查看所有上课日期</span
        >
      </h2>
      <div class="select-dates" @click="components.chooseDate = true">
        <div v-if="openingDate">
          {{ openingDate.dateText }}{{ openingDate.dayText }} {{ openingDate.time }} -
          {{ openingDate.timeEnd }}
        </div>
        <div v-else>请选择开课日期</div>
      </div>
      <!-- <div class="select-dates">
        <select v-if="openingDates[0]" v-model="openingDate">
          <option value selected disabled>请选择开课日期</option>
          <option v-for="(value, key) in openingDates" :key="key" :value="value"
            >{{ value.dateText }}{{ value.dayText }} {{ value.time }} - {{ value.timeEnd }}</option
          >
        </select>
      </div> -->
    </div>
    <div class="select-wrapper">
      <h2 class="title">上课地点</h2>
      <div @click="isShowAddress = true">
        <h3 v-if="address">{{ address.address }}</h3>
        <h3 v-else>选择地址</h3>
      </div>
    </div>
    <Calendar v-if="isShowCalendar" :dates="datesOfClasses" @close="isShowCalendar = false" />
    <keep-alive>
      <AddressBook
        v-if="isShowAddress"
        :selected="address"
        class="address-book"
        @address="onAddress($event)"
      />
    </keep-alive>
    <div v-if="openingDate && address" class="action-button" @click="$emit('state', 1)">下一步</div>
    <div v-else class="action-button button-disabled">下一步</div>
  </div>
</template>
<script>
import Calendar from "../../homeclass/dates"
import AddressBook from "../../address/Main"
export default {
  name: "Date",
  components: {
    Calendar,
    AddressBook,
  },
  props: ["data"],
  data() {
    return {
      components: {
        chooseDate: false
      },
      dateObjOfClasses: [],
      openingDates: [],
      openingDate: "",
      datesOfClasses: [],
      timesOfClasses: [],
      address: "",
      isShowCalendar: false,
      isShowAddress: false,
    }
  },
  watch: {
    openingDate: function (val) {
      if (val) {
        this.getDates()
        this.components.chooseDate = false
      }
      this.$emit("update", { openingDate: val })
    },
    address: function (val) {
      this.$emit("update", { address: val })
    },
    dateObjOfClasses: function (val) {
      this.$emit("update", { dateObjOfClasses: val })
    },
  },
  activated() {
    this.getOpeningDates()
    if (this.openingDate) {
      this.getDates()
    }
  },
  methods: {
    emit(type) {
      sessionStorage["dates"] = JSON.stringify(this.datesOfClasses)
      bus.emit(type, this.$el)
    },
    onAddress(e) {
      this.isShowAddress = false
      this.address = e.a_id ? e : ""
    },
    getOpeningDates() {
      this.openingDates = []
      this.datesOfClasses = []
      let d = new Date()
      d = bus.incrementDate(d, 2)
      for (let i = 0; i < 30; i++) {
        if (this.data.daysOfClasses.includes(d.getDay())) {
          this.openingDates.push(
            bus.getDateObj(
              d,
              this.data.timeslot[d.getDay()].time,
              this.data.timeslot[d.getDay()].timeEnd,
            ),
          )
        }
        d = bus.incrementDate(d)
      }
      if (
        this.openingDate &&
        this.openingDates.every(
          item => item.mmdd != this.openingDate.mmdd || item.time != this.openingDate.time,
        )
      ) {
        this.openingDate = ""
      }
    },
    getDates() {
      this.dateObjOfClasses = []
      let d = new Date(this.openingDate.mmdd)
      let numOfClasses = this.data.sessions.regular + this.data.sessions.extra
      while (numOfClasses > 0) {
        if (this.data.daysOfClasses.includes(d.getDay())) {
          this.dateObjOfClasses.push(
            bus.getDateObj(
              d,
              this.data.timeslot[d.getDay()].time,
              this.data.timeslot[d.getDay()].timeEnd,
            ),
          )
          numOfClasses--
        }
        d = bus.incrementDate(d)
      }
      this.datesOfClasses = this.dateObjOfClasses.map(item => item.mmdd)
      this.timesOfClasses = this.dateObjOfClasses.map(item => item.time)
      this.$emit("update", { datesOfClasses: this.datesOfClasses })
      this.$emit("update", { timesOfClasses: this.timesOfClasses })
    },
  },
}
</script>
<style scoped lang="scss">
// @import "../../../../static/css/public.scss";
@import "../../../../static/css/prog-form.scss";
@import "../../../../static/css/radio.scss";

#select-dates-wrapper {
  .show-dates {
    font-size: 13px;
    color: #ff5d67;
    font-weight: 500;
    float: right;
    animation-delay: 0s !important;
    animation-duration: 0.5s !important;
  }
  .select-dates {
    padding: 5px 0 15px 0;
    font-size: 15px;
  }
}

.choose-date {
  .radio {
    padding: 0 !important;
  }
}
</style>
